import React, { Component } from 'react';
import Screenshot from './Screenshot';
import Fade from 'react-reveal/Fade';
import TransitionGroup from 'react-transition-group/TransitionGroup';


class ScreenshotGrid extends Component {
	constructor (props) {
		super(props)
		this.state = {
			project: this.props.project,
			projectJSON: this.props.JSON
		}
		this.appController = this.appController.bind(this)
    }

    appController (imgObj,displayState) {
      this.props.controllerCB(imgObj,"true",true)
    }

    buildImages(screenshotsArray)  {
      this.props.setSSContextCB(screenshotsArray)
      //console.log('build images fired')
    	var imgs = []
    	//console.log('Screenshot Array is'+ JSON.stringify(screenshotsArray))
     
    	imgs = screenshotsArray.map((screenshot,index) => 
         <Fade>
        <Screenshot nextSSIndex={index+1} prevSSIndex={index-1} controller={this.appController} src={this.imgpath+screenshot.imgsrc} key={index} height={screenshot.height} width={screenshot.width} />
    		 </Fade>
         //<img src={require(`${this.imgpath+screenshot.imgsrc}`)} key={screenshot.id} height={screenshot.height} width={screenshot.width} className="screenImgThumb" alt="test"/>
        )


    	return (
    		<div className="imgContainer">
         
        
    		  {imgs}
       
      
    		</div>
    		)

    }

    buildSections(){

 		var html = []
 		//this.setState({project: this.props.project})
   
		this.data = this.props.JSON
		this.sections = this.data.sections	
		this.imgpath=this.data.imgpath
 		var displayObjs = this.sections 
 		//console.log('Screenshot JSON is'+ this.sections)
		//console.log("html is" + displayObjs[0].section.name)
 		html = displayObjs.map((displayObj,index) => 
 			<div className="sectionContainer" key={index}>
          
          	{this.buildImages(displayObj.section.screenshots)}
          	</div>
        )
		
    	return (
 			<div className="sectionBoundary">
 			{html}
 			</div>
    		)
    }

  render() {
  		//console.log('Screenshot JSON is'+ this.props.JSON)
        if(this.props.JSON !== undefined ){
		    return (
		    	<div className="sectionFence">
          <TransitionGroup component={null}>
		    	{this.buildSections()}
		      </TransitionGroup>
		      	</div> 
		    )
		} else {
			return <div>no screenshots for this project</div>
		}

  }
}

export default ScreenshotGrid;


// WEBPACK FOOTER //
// ./src/ScreenshotGrid.js